"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2912],{

/***/ 21609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _iconify_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1954);
// ** Icon Imports


const IconifyIcon = (param)=>{
    let { icon , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO, {
        icon: icon,
        fontSize: "1.5rem",
        ...rest
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconifyIcon);


/***/ }),

/***/ 23077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lc": function() { return /* binding */ applyBoundDeviceByOrderId; },
/* harmony export */   "bI": function() { return /* binding */ getDashboardPathByPlatform; }
/* harmony export */ });
/* unused harmony exports parseSearchParams, applyUserDeviceById, handleAppDeviceBridge */
/* harmony import */ var src_api_login__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53399);
/* harmony import */ var src_utils_switchDevice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83989);
/* harmony import */ var src_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89365);
/* harmony import */ var src_components_Message__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29143);
/* harmony import */ var src_utils_subscriptionStatus__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38365);
/* harmony import */ var src_utils_refreshSidebarDevices__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66512);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);







/**
 * 解析 URL search 为键值对象。
 * @param {string} search - 如 ?from_app=1&user_device_id=123
 * @returns {Object|null}
 */ const parseSearchParams = (search)=>{
    try {
        var ref;
        const query = (ref = search.match(/\?([^#]+)/)) === null || ref === void 0 ? void 0 : ref[1];
        if (!query) return null;
        const obj = {};
        query.split("&").forEach((pair)=>{
            const [key, value = ""] = pair.split("=");
            if (!key) return;
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        });
        return obj;
    } catch (e) {
        return null;
    }
};
/**
 * 按平台类型返回对应 Dashboard 路径。
 * @param {string} platformType
 * @returns {string}
 */ const getDashboardPathByPlatform = (platformType)=>{
    if (platformType === "Android-Cloud") return "/android/dashboard";
    if (platformType === "Android-Local") return "/android/local/dashboard";
    return "/dashboard";
};
var ref, ref1, ref2;
const buildDeviceUserPayload = (device)=>{
    return {
        username: device.iCloud_username,
        password: device.iCloud_password,
        temporary: device.temporary,
        expire_time: device.expire_time,
        likeType: device.like_type,
        device_id: (device === null || device === void 0 ? void 0 : device.id) || (device === null || device === void 0 ? void 0 : device.device_id) || "",
        order_id: (ref1 = (ref = device === null || device === void 0 ? void 0 : device.order_id) !== null && ref !== void 0 ? ref : device === null || device === void 0 ? void 0 : device.orderId) !== null && ref1 !== void 0 ? ref1 : null,
        subscription_status: (ref2 = device === null || device === void 0 ? void 0 : device.subscription_status) !== null && ref2 !== void 0 ? ref2 : null
    };
};
var ref3, ref4, ref5, ref6;
const getDeviceOrderId = (device)=>{
    var ref, ref1;
    return (ref6 = (ref5 = (ref4 = (ref3 = device === null || device === void 0 ? void 0 : device.order_id) !== null && ref3 !== void 0 ? ref3 : device === null || device === void 0 ? void 0 : device.orderId) !== null && ref4 !== void 0 ? ref4 : device === null || device === void 0 ? void 0 : (ref = device.Order) === null || ref === void 0 ? void 0 : ref.id) !== null && ref5 !== void 0 ? ref5 : device === null || device === void 0 ? void 0 : (ref1 = device.order) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref6 !== void 0 ? ref6 : null;
};
const applySelectedDevice = (param)=>{
    let { device , devices  } = param;
    if (!device) {
        return {
            ok: false,
            error: "not_found"
        };
    }
    if (!(0,src_utils_subscriptionStatus__WEBPACK_IMPORTED_MODULE_4__/* .isSelectableDevice */ .He)(device)) {
        return {
            ok: false,
            error: "lapsed_device_not_selectable"
        };
    }
    const deviceUser = buildDeviceUserPayload(device);
    localStorage.setItem("allDeviceUser", JSON.stringify(devices));
    localStorage.setItem("currentDevice", JSON.stringify({}));
    localStorage.setItem("Basic", device.iCloud_username ? 1 : 0);
    // 统一更新 localStorage 和切换状态；Redux 选中值保持为 device_id。
    const switched = (0,src_utils_switchDevice__WEBPACK_IMPORTED_MODULE_1__/* .switchDevice */ .m)({
        dispatch: src_store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch,
        deviceUser,
        currentDevice: {},
        currentMode: device.platform_type
    });
    if (!switched) {
        return {
            ok: false,
            error: "lapsed_device_not_selectable"
        };
    }
    return {
        ok: true,
        platformType: device.platform_type,
        dashboardPath: getDashboardPathByPlatform(device.platform_type)
    };
};
/**
 * 按 user_device_id 选中设备并走 switchDevice。
 * @param {string|number} userDeviceId
 * @returns {Promise<{ ok: boolean, platformType?: string, dashboardPath?: string, error?: string }>}
 */ const applyUserDeviceById = async (userDeviceId)=>{
    const res = await getAllUserDevice({});
    const devices = Array.isArray(res === null || res === void 0 ? void 0 : res.data) ? res.data : [];
    const device = devices.find((item)=>String(item.id) === String(userDeviceId));
    return applySelectedDevice({
        device,
        devices
    });
};
/**
 * 绑定成功后按 orderId 选中刚写入的设备。
 *
 * 为何先等再重试：
 * - 绑定接口返回 SUCCESS 时，设备记录可能尚未出现在 getAllUserDevice 里。
 * - initialDelay 后再拉，失败则按 retryDelay 重试 attempts 次。
 *
 * 为何 finally 里一定 refreshSidebarDevices：
 * - 绑定瞬间的 refresh 往往太早，侧栏 notBindOrder 仍是「Package / Connect the device now」。
 * - 移动端抽屉 keepMounted，不 remount，不靠重进页面刷新。
 * - 等设备写入窗口过后再刷一次，才能清掉未绑 Package、展示已绑设备。
 * - 选中成败都刷：即使没选上，侧栏列表也要跟后端对齐。
 */ const applyBoundDeviceByOrderId = async function() {
    let { orderId , platformType , attempts =3 , retryDelay =800 , initialDelay =800  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (orderId == null || orderId === "") {
        return {
            ok: false,
            error: "missing_order_id"
        };
    }
    // 给后端一点写入时间，避免一绑完立刻拉列表为空
    if (initialDelay > 0) {
        await new Promise((resolve)=>setTimeout(resolve, initialDelay));
    }
    let result = {
        ok: false,
        error: "bound_device_not_found"
    };
    const totalAttempts = Math.max(1, Number(attempts) || 1);
    try {
        for(let attempt = 0; attempt < totalAttempts; attempt += 1){
            const res = await (0,src_api_login__WEBPACK_IMPORTED_MODULE_0__.getAllUserDevice)({});
            const devices = Array.isArray(res === null || res === void 0 ? void 0 : res.data) ? res.data : [];
            const device = devices.find((item)=>{
                const sameOrder = String(getDeviceOrderId(item)) === String(orderId);
                const samePlatform = !platformType || (item === null || item === void 0 ? void 0 : item.platform_type) === platformType;
                return sameOrder && samePlatform;
            });
            if (device) {
                // 写入 DeviceUser + Redux 选中，侧栏高亮切到新设备
                result = applySelectedDevice({
                    device,
                    devices
                });
                break;
            }
            if (attempt < totalAttempts - 1) {
                await new Promise((resolve)=>setTimeout(resolve, retryDelay));
            }
        }
    } finally{
        // 必刷侧栏：重拉设备列表 + 未绑订单，去掉过期的 Package 卡
        await (0,src_utils_refreshSidebarDevices__WEBPACK_IMPORTED_MODULE_5__/* .refreshSidebarDevices */ .Ii)();
    }
    return result;
};
/**
 * App 深链入站：解析 from_app / user_device_id 并切换设备。
 * @param {string} search - window.location.search
 * @returns {Promise<{ handled: boolean, ok?: boolean, error?: string }>}
 */ const handleAppDeviceBridge = async (search)=>{
    const params = parseSearchParams(search);
    if (!params || params.from_app !== "1") {
        return {
            handled: false
        };
    }
    // App 跳转来源平台持久化；入参可能是 iOS/Android，写入前统一小写
    if (params.app_platform) {
        sessionStorage.setItem("app_platform", String(params.app_platform).trim().toLowerCase());
    }
    const userDeviceId = params.user_device_id;
    // 绑定/setup 场景只需 orderId，device id 非必须；无 user_device_id 时不提示、不处理设备桥接
    if (!userDeviceId) {
        return {
            handled: false
        };
    }
    try {
        const result = await applyUserDeviceById(userDeviceId);
        if (!result.ok) {
            messageInfo("Invalid user_device_id");
            return {
                handled: true,
                ok: false,
                error: result.error
            };
        }
        const { dashboardPath  } = result;
        if (window.location.pathname !== dashboardPath) {
            Router.push(dashboardPath);
            return {
                handled: true,
                ok: true,
                ...result
            };
        }
        if (window.location.search) {
            window.history.replaceState(null, "", dashboardPath);
        }
        return {
            handled: true,
            ok: true,
            ...result
        };
    } catch (e) {
        messageInfo("Failed to load device");
        return {
            handled: true,
            ok: false,
            error: "request_failed"
        };
    }
};


/***/ }),

/***/ 45210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ln": function() { return /* binding */ resolveBindingDeviceResponse; },
/* harmony export */   "iQ": function() { return /* binding */ BINDING_OUTCOME; }
/* harmony export */ });
/* unused harmony exports getBindingDeviceOutcome, isBindingDeviceSuccess, redirectAfterAlreadyBound */
/* harmony import */ var src_utils_appDeviceBridge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23077);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_utils_refreshSidebarDevices__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66512);



const BINDING_OUTCOME = {
    SUCCESS: "success",
    ALREADY_BOUND: "already_bound",
    EXPIRED: "expired",
    FAILED: "failed"
};
/**
 * 解析 user-binding-device / order-binding-device 响应。
 * 优先读 bindStatus；无该字段时兼容旧返回。
 * @param {object|null|undefined} result
 * @returns {'success'|'already_bound'|'expired'|'failed'}
 */ const getBindingDeviceOutcome = (result)=>{
    if (!result) return BINDING_OUTCOME.FAILED;
    const status = result.bindStatus;
    if (status === BINDING_OUTCOME.ALREADY_BOUND) return BINDING_OUTCOME.ALREADY_BOUND;
    if (status === BINDING_OUTCOME.EXPIRED) return BINDING_OUTCOME.EXPIRED;
    if (status === BINDING_OUTCOME.SUCCESS) return BINDING_OUTCOME.SUCCESS;
    if (status === BINDING_OUTCOME.FAILED) return BINDING_OUTCOME.FAILED;
    if (result.code === 1001) return BINDING_OUTCOME.EXPIRED;
    if (result.code === 500 && result.msg === "Expired") return BINDING_OUTCOME.EXPIRED;
    if (result.code === 0) return BINDING_OUTCOME.SUCCESS;
    return BINDING_OUTCOME.FAILED;
};
const isBindingDeviceSuccess = (result)=>getBindingDeviceOutcome(result) === BINDING_OUTCOME.SUCCESS;
const clearBindOrderCache = ()=>{
    try {
        localStorage.removeItem("ontBindOrder");
    } catch (e) {
    // ignore
    }
};
/**
 * 已绑定：清缓存并跳转对应 Dashboard。
 * @param {{ platformType?: string, router?: { push?: Function } }} [opts]
 */ const redirectAfterAlreadyBound = function() {
    let { platformType , router  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    clearBindOrderCache();
    (0,src_utils_refreshSidebarDevices__WEBPACK_IMPORTED_MODULE_2__/* .refreshSidebarDevices */ .Ii)();
    const target = (0,src_utils_appDeviceBridge__WEBPACK_IMPORTED_MODULE_0__/* .getDashboardPathByPlatform */ .bI)(platformType);
    if (typeof (router === null || router === void 0 ? void 0 : router.push) === "function") {
        router.push(target);
    } else if (true) {
        next_router__WEBPACK_IMPORTED_MODULE_1___default().push(target);
    }
};
/**
 * 统一处理绑定接口结果：toast + already_bound 跳转。
 * @returns {{ outcome: string, ok: boolean, shouldContinue: boolean }}
 */ const resolveBindingDeviceResponse = function(result) {
    let { platformType , router , onMessage , t  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const outcome = getBindingDeviceOutcome(result);
    const translate = typeof t === "function" ? t : (key)=>key;
    const notify = typeof onMessage === "function" ? onMessage : ()=>{};
    if (outcome === BINDING_OUTCOME.ALREADY_BOUND) {
        notify({
            content: (result === null || result === void 0 ? void 0 : result.msg) || translate("Device already bound"),
            type: "info"
        });
        redirectAfterAlreadyBound({
            platformType,
            router
        });
        return {
            outcome,
            ok: true,
            shouldContinue: false
        };
    }
    if (outcome === BINDING_OUTCOME.SUCCESS) {
        (0,src_utils_refreshSidebarDevices__WEBPACK_IMPORTED_MODULE_2__/* .refreshSidebarDevices */ .Ii)();
        return {
            outcome,
            ok: true,
            shouldContinue: true
        };
    }
    if (outcome === BINDING_OUTCOME.EXPIRED) {
        notify({
            content: translate("device expired") || (result === null || result === void 0 ? void 0 : result.msg) || "Expired",
            type: "error"
        });
        return {
            outcome,
            ok: false,
            shouldContinue: false
        };
    }
    if (result === null || result === void 0 ? void 0 : result.msg) {
        notify({
            content: result.msg,
            type: "error"
        });
    }
    return {
        outcome,
        ok: false,
        shouldContinue: false
    };
};


/***/ }),

/***/ 66512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ii": function() { return /* binding */ refreshSidebarDevices; },
/* harmony export */   "MD": function() { return /* binding */ SIDEBAR_DEVICES_REFRESH_EVENT; }
/* harmony export */ });
/* harmony import */ var src_api_login__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53399);

/** 侧栏设备 / 未绑订单刷新事件（Equipment / AndroidEquipment 监听） */ const SIDEBAR_DEVICES_REFRESH_EVENT = "sidebarDevicesRefresh";
/**
 * 绑定完成后刷新侧栏：
 * 1. 重拉 getAllUserDevice 写入 allDeviceUser
 * 2. 广播事件，驱动侧栏再请求设备列表 + getNotBindOrder
 */ const refreshSidebarDevices = async ()=>{
    if (false) {}
    try {
        const res = await (0,src_api_login__WEBPACK_IMPORTED_MODULE_0__.getAllUserDevice)({});
        localStorage.setItem("allDeviceUser", JSON.stringify(Array.isArray(res === null || res === void 0 ? void 0 : res.data) ? res.data : []));
    } catch (e) {
        ;
    }
    window.dispatchEvent(new CustomEvent(SIDEBAR_DEVICES_REFRESH_EVENT));
    return {
        ok: true
    };
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (refreshSidebarDevices)));


/***/ }),

/***/ 96613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EI": function() { return /* binding */ parseExpireMs; },
/* harmony export */   "Jn": function() { return /* binding */ THIRTY_DAYS_MS; },
/* harmony export */   "ku": function() { return /* binding */ resolveDeviceExpireTime; },
/* harmony export */   "l": function() { return /* binding */ buildDeviceUserPayload; }
/* harmony export */ });
/* unused harmony exports isSubscriptionActive, isDeviceActive, isExpiredPastGracePeriod, areAllDevicesExpiredPastGrace, isDeviceWithinGracePeriod, shouldShowExpiredMask, pickFirstActiveDevice */
/**
 * 解析 expire_time 为 UTC 毫秒时间戳。
 * ISO 8601 带 Z（如 2026-11-16T07:35:07.623Z）会被正确解析为绝对时刻，与用户本地时区无关。
 */ const parseExpireMs = (raw)=>{
    if (raw == null || raw === "") return NaN;
    const ms = new Date(raw).getTime();
    return Number.isFinite(ms) ? ms : NaN;
};
/** 订阅仍有效：无 expire_time 视为有效；否则 expire_time >= 当前时刻 */ const isSubscriptionActive = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    const ms = parseExpireMs(expireTime);
    if (!Number.isFinite(ms)) return true;
    return ms >= now;
};
const isDeviceActive = (device)=>{
    return isSubscriptionActive(device === null || device === void 0 ? void 0 : device.expire_time);
};
const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;
/** 已过期且超过宽限期（默认 30 天） */ const isExpiredPastGracePeriod = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    const ms = parseExpireMs(expireTime);
    if (!Number.isFinite(ms)) return false;
    if (ms >= now) return false;
    return now - ms > graceMs;
};
/** 全部设备均已过期且超过宽限期 */ const areAllDevicesExpiredPastGrace = function(devices) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    const list = Array.isArray(devices) ? devices : [];
    if (!list.length) return false;
    return list.every((device)=>{
        return isExpiredPastGracePeriod(device === null || device === void 0 ? void 0 : device.expire_time, now, graceMs);
    });
};
/** 从侧栏设备项（数组或单条记录）解析 expire_time */ const resolveDeviceExpireTime = (item)=>{
    var ref, ref1, ref2;
    if (!item) return null;
    if (item.expire_time != null && item.expire_time !== "") return item.expire_time;
    if (Array.isArray(item) && ((ref = item[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.DeviceUser) === null || ref1 === void 0 ? void 0 : ref1.expire_time)) return item[0].DeviceUser.expire_time;
    if (item === null || item === void 0 ? void 0 : (ref2 = item.DeviceUser) === null || ref2 === void 0 ? void 0 : ref2.expire_time) return item.DeviceUser.expire_time;
    return null;
};
/** 侧栏仍展示：未过期、无 expire_time、或过期未超过 graceDays（默认 30 天） */ const isDeviceWithinGracePeriod = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    const ms = parseExpireMs(expireTime);
    if (!Number.isFinite(ms)) return true;
    if (ms >= now) return true;
    return now - ms <= graceMs;
};
/** Feature 详情页遮罩：已过期且在宽限期内（默认 30 天） */ const shouldShowExpiredMask = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    return !isSubscriptionActive(expireTime, now) && isDeviceWithinGracePeriod(expireTime, now, graceMs);
};
/** 取第一个可选中设备：优先未过期(active)，其次宽限期(grace)；永不返回超 30 天失效 */ const pickFirstActiveDevice = (devices, platformType)=>{
    const list = Array.isArray(devices) ? devices : [];
    const scoped = platformType ? list.filter((item)=>{
        return (item === null || item === void 0 ? void 0 : item.platform_type) === platformType;
    }) : list;
    const now = Date.now();
    const selectable = scoped.filter((item)=>{
        const ms = parseExpireMs(item === null || item === void 0 ? void 0 : item.expire_time);
        if (!Number.isFinite(ms)) return true;
        if (ms >= now) return true;
        return now - ms <= THIRTY_DAYS_MS;
    });
    if (!selectable.length) return null;
    return selectable.find(isDeviceActive) || selectable[0] || null;
};
var ref, ref1, ref2;
const buildDeviceUserPayload = (device)=>{
    return {
        username: device.iCloud_username,
        password: device.iCloud_password,
        temporary: device.temporary,
        expire_time: device.expire_time,
        likeType: device.like_type,
        device_id: (device === null || device === void 0 ? void 0 : device.id) || (device === null || device === void 0 ? void 0 : device.device_id) || "",
        order_id: (ref1 = (ref = device === null || device === void 0 ? void 0 : device.order_id) !== null && ref !== void 0 ? ref : device === null || device === void 0 ? void 0 : device.orderId) !== null && ref1 !== void 0 ? ref1 : null,
        subscription_status: (ref2 = device === null || device === void 0 ? void 0 : device.subscription_status) !== null && ref2 !== void 0 ? ref2 : null
    };
};


/***/ }),

/***/ 38365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "He": function() { return /* binding */ isSelectableDevice; },
/* harmony export */   "MA": function() { return /* binding */ resolveDeviceSubscriptionStatus; },
/* harmony export */   "Mi": function() { return /* binding */ resolveInitialEntry; },
/* harmony export */   "Xz": function() { return /* binding */ getDeviceNotSelectableMessage; },
/* harmony export */   "cw": function() { return /* binding */ isGraceDevice; },
/* harmony export */   "dv": function() { return /* binding */ validateDeviceSelection; },
/* harmony export */   "mJ": function() { return /* binding */ isDeviceVisibleInSidebar; },
/* harmony export */   "oT": function() { return /* binding */ pickPreferredSelectableDevice; },
/* harmony export */   "q6": function() { return /* binding */ shouldEnterExpiredPurchasePage; },
/* harmony export */   "qq": function() { return /* binding */ SUBSCRIPTION_STATUS; },
/* harmony export */   "w4": function() { return /* binding */ resolveDeviceOrderId; }
/* harmony export */ });
/* unused harmony exports normalizeSubscriptionStatus, resolveSubscriptionStatus, isSelectableSubscriptionStatus, isLapsedDevice, isNoneDevice, areAllDevicesLapsed, areAllDevicesNonSelectable */
/* harmony import */ var src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96613);

/** 设备订阅状态机（与后端 user-device.subscription_status 对齐） */ const SUBSCRIPTION_STATUS = Object.freeze({
    /** 未过期 */ ACTIVE: "active",
    /** 已过期且 ≤30 天（含第 30 天，宽限期，仍可选中） */ GRACE: "grace",
    /** 已过期且 >30 天（失效，禁止选中） */ LAPSED: "lapsed",
    /**
   * 特殊态：无已支付订单，或 expire_time 为空/异常。
   * ≠ lapsed：不进「全员超 30 天」独立续费页；也不可选中。
   */ NONE: "none"
});
const STATUS_SET = new Set(Object.values(SUBSCRIPTION_STATUS));
const normalizeSubscriptionStatus = (raw)=>{
    if (raw == null || raw === "") return null;
    const status = String(raw).toLowerCase();
    return STATUS_SET.has(status) ? status : null;
};
/**
 * 由 expire_time 本地兜底（接口未回 subscription_status 时用）。
 * 无有效 expire_time → active（兼容历史无到期字段仍可进 dashboard）。
 * 服务端显式 none 时走 subscription_status 字段，不走本函数。
 */ const resolveSubscriptionStatus = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    const ms = (0,src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .parseExpireMs */ .EI)(expireTime);
    if (!Number.isFinite(ms)) return SUBSCRIPTION_STATUS.ACTIVE;
    if (ms >= now) return SUBSCRIPTION_STATUS.ACTIVE;
    if (now - ms <= graceMs) return SUBSCRIPTION_STATUS.GRACE;
    return SUBSCRIPTION_STATUS.LAPSED;
};
/**
 * 优先用设备/DeviceUser 上的 subscription_status；否则用 expire_time 兜底。
 */ const resolveDeviceSubscriptionStatus = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    const fromApi = normalizeSubscriptionStatus(device === null || device === void 0 ? void 0 : device.subscription_status);
    if (fromApi) return fromApi;
    var ref;
    return resolveSubscriptionStatus((ref = (0,src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .resolveDeviceExpireTime */ .ku)(device)) !== null && ref !== void 0 ? ref : device === null || device === void 0 ? void 0 : device.expire_time, now, graceMs);
};
/** active / grace 可选中；lapsed / none 禁止成为当前选中 */ const isSelectableSubscriptionStatus = (status)=>status === SUBSCRIPTION_STATUS.ACTIVE || status === SUBSCRIPTION_STATUS.GRACE;
const isSelectableDevice = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    if (!device) return false;
    return isSelectableSubscriptionStatus(resolveDeviceSubscriptionStatus(device, now, graceMs));
};
const isLapsedDevice = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    return resolveDeviceSubscriptionStatus(device, now, graceMs) === SUBSCRIPTION_STATUS.LAPSED;
};
const isGraceDevice = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    return resolveDeviceSubscriptionStatus(device, now, graceMs) === SUBSCRIPTION_STATUS.GRACE;
};
const isNoneDevice = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    return resolveDeviceSubscriptionStatus(device, now, graceMs) === SUBSCRIPTION_STATUS.NONE;
};
/**
 * 侧栏设备卡片是否展示：
 * - active / grace：展示
 * - none：展示（特殊：无有效已付单，但仍是绑定记录）
 * - lapsed：隐藏
 */ const isDeviceVisibleInSidebar = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    if (!device) return false;
    return resolveDeviceSubscriptionStatus(device, now, graceMs) !== SUBSCRIPTION_STATUS.LAPSED;
};
/**
 * 设备关联已支付订单 ID（后端 user-device.order_id）。
 * @returns {string|number|null}
 */ const resolveDeviceOrderId = (device)=>{
    var ref, ref1;
    if (!device) return null;
    var _order_id, ref2, ref3;
    const id = (ref3 = (ref2 = (_order_id = device.order_id) !== null && _order_id !== void 0 ? _order_id : device.orderId) !== null && ref2 !== void 0 ? ref2 : device === null || device === void 0 ? void 0 : (ref = device.Order) === null || ref === void 0 ? void 0 : ref.id) !== null && ref3 !== void 0 ? ref3 : device === null || device === void 0 ? void 0 : (ref1 = device.order) === null || ref1 === void 0 ? void 0 : ref1.id;
    if (id == null || id === "") return null;
    return id;
};
/**
 * 初始化/恢复选中：优先 active，其次 grace；永不返回 lapsed/none。
 * @param {Array} devices
 * @param {string} [platformType]
 */ const pickPreferredSelectableDevice = (devices, platformType)=>{
    const list = Array.isArray(devices) ? devices : [];
    const scoped = platformType ? list.filter((item)=>{
        return (item === null || item === void 0 ? void 0 : item.platform_type) === platformType;
    }) : list;
    const selectable = scoped.filter((item)=>isSelectableDevice(item));
    if (!selectable.length) return null;
    const active = selectable.find((item)=>resolveDeviceSubscriptionStatus(item) === SUBSCRIPTION_STATUS.ACTIVE);
    return active || selectable[0] || null;
};
/**
 * 选中校验：仅 active/grace 可选。
 * @returns {{ ok: boolean, status: string, reason?: string }}
 */ const validateDeviceSelection = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    if (!device || typeof device === "object" && !Object.keys(device).length) {
        return {
            ok: true,
            status: SUBSCRIPTION_STATUS.NONE
        };
    }
    const status = resolveDeviceSubscriptionStatus(device, now);
    if (!isSelectableSubscriptionStatus(status)) {
        return {
            ok: false,
            status,
            reason: status === SUBSCRIPTION_STATUS.LAPSED ? "lapsed_device_not_selectable" : "device_not_selectable"
        };
    }
    return {
        ok: true,
        status
    };
};
/** 侧栏不可选设备的英文提示（none ≠ 过期） */ const getDeviceNotSelectableMessage = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    const status = resolveDeviceSubscriptionStatus(device, now);
    if (status === SUBSCRIPTION_STATUS.NONE) {
        return "This package has no active subscription and cannot be selected.";
    }
    if (status === SUBSCRIPTION_STATUS.LAPSED) {
        return "This package subscription has expired and cannot be selected.";
    }
    return "This package cannot be selected.";
};
/**
 * 是否「全部设备都是 lapsed」。
 * none 不算 lapsed（有 none 混在时为 false）。
 * 只信 subscription_status（无字段时才 expire_time 兜底）。
 */ const areAllDevicesLapsed = function(devices) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    const list = Array.isArray(devices) ? devices : [];
    if (!list.length) return false;
    return list.every((device)=>isLapsedDevice(device, now, graceMs));
};
/** 无任何可选中设备（全是 lapsed / none） */ const areAllDevicesNonSelectable = function(devices) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    const list = Array.isArray(devices) ? devices : [];
    if (!list.length) return false;
    return list.every((device)=>!isSelectableDevice(device, now, graceMs));
};
/**
 * 独立续费页入口（替换旧「全设备过期超 30 天 + 无未绑单」本地推算）：
 * - 设备非空且全部 subscription_status === lapsed
 * - 且 not-bind-order 无有效未绑单
 *
 * none 不进此页。
 */ const shouldEnterExpiredPurchasePage = function() {
    let { devices =[] , validUnboundOrders =[]  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const list = Array.isArray(devices) ? devices : [];
    const unbound = Array.isArray(validUnboundOrders) ? validUnboundOrders : [];
    return list.length > 0 && areAllDevicesLapsed(list) && unbound.length === 0;
};
/**
 * 登录/进站：active/grace 设备 > 未绑单 > 空态
 * 「全部过期超 30 天」的判定由 userEntryGate 负责（后端状态优先），这里不参与。
 * 永不选中 lapsed/none。
 * @returns {{ type: 'device'|'unbound'|'empty', device: object|null }}
 */ const resolveInitialEntry = function() {
    let { devices =[] , validUnboundOrders =[] , preferredMode =null , preferredDevice =null  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const list = Array.isArray(devices) ? devices : [];
    const unbound = Array.isArray(validUnboundOrders) ? validUnboundOrders : [];
    if (preferredDevice && isSelectableDevice(preferredDevice)) {
        return {
            type: "device",
            device: preferredDevice
        };
    }
    const preferred = pickPreferredSelectableDevice(list, preferredMode) || pickPreferredSelectableDevice(list);
    if (preferred) {
        return {
            type: "device",
            device: preferred
        };
    }
    if (unbound.length > 0) {
        return {
            type: "unbound",
            device: null
        };
    }
    return {
        type: "empty",
        device: null
    };
};


/***/ })

}]);